import {
  FUTURE_PLANNING_YEARS,
  MIN_PLANNING_YEAR,
} from '../../config/business';

interface BuildPlanningYearOptionsParams {
  startYear?: number;
  currentYear?: number;
  futureYears?: number;
  selectedYear?: number;
  yearsCount?: number;
}

export const buildPlanningYearOptions = ({
  startYear = MIN_PLANNING_YEAR,
  currentYear = new Date().getFullYear(),
  futureYears = FUTURE_PLANNING_YEARS,
  selectedYear,
  yearsCount,
}: BuildPlanningYearOptionsParams = {}) => {
  const configuredEndYear = yearsCount === undefined
    ? currentYear + futureYears
    : startYear + Math.max(yearsCount, 1) - 1;
  const endYear = Math.max(configuredEndYear, selectedYear ?? configuredEndYear, startYear);

  return Array.from({ length: endYear - startYear + 1 }, (_, i) => {
    const year = startYear + i;
    return { label: `${year} год`, value: year };
  });
};
